<template>
    <a href="#" data-toggle="modal" data-target="#pos" data-backdrop="static"
       data-keyboard="false">
        <span v-if="$store.getters[`schedules/getSchedulePO`]">PO# {{$store.getters[`schedules/getSchedulePO`]}}</span>
        <slot v-else>
            <span> PO Required {{po_required ? 'Yes' : 'No'}}</span>
        </slot>
    </a>

</template>

<script>

export default {
    name: "PONumber",
        props: ['po_number', 'po_required'],
    data() {

    },
    mounted() {
        if (this.po_number){
            this.$store.commit('schedules/schedulePO', this.po_number)
        }
    },
    methods: {

    }
}
</script>

<style scoped>


</style>
